export default __webpack_public_path__ + "7d87f5a00f6926298491b7398967d21c.svg";